"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefractiveIndex = void 0;
const physical_parser_1 = require("physical-parser");
const extractExperimentalData_1 = require("./extractExperimentalData");
/**
 * Returns the refractive index of a compound
 * @param data Data of a compound data request to the PubChem API
 * @returns ExperimentalData
 */
function getRefractiveIndex(data = {}) {
    const refractiveIndex = (0, extractExperimentalData_1.extractExperimentalData)(data, 'Refractive Index', {
        parser: (value) => (0, physical_parser_1.parseRefractiveIndex)(value),
    });
    return refractiveIndex;
}
exports.getRefractiveIndex = getRefractiveIndex;
//# sourceMappingURL=getRefractiveIndex.js.map